// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareMicroscopeDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5 0H11V14L10 16H6L5 14V0Z" class="svg-bg"/>
  <path d="M6 22L5 24H12.884C12.8856 24 12.8871 24 12.8887 24C12.8902 24 12.8918 24 12.8933 24L21 24L20 22H19.2521C22.1114 20.0093 24 16.7203 24 13C24 6.95546 19.0144 2.04963 12.9804 2.00037V4.00001L13 3.99999C17.9706 3.99999 22 8.02943 22 13C22 17.9706 17.9706 22 13 22L6 22Z" class="svg-bg"/>
  <path d="M0 18H13V20H0V18Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareMicroscopeDefault is a generated icon component.
 */
let IconHardwareMicroscopeDefault = IconHardwareMicroscopeDefault_1 = class IconHardwareMicroscopeDefault extends IconBaseElement {
    render() {
        return html `${IconHardwareMicroscopeDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareMicroscopeDefault.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareMicroscopeDefault = IconHardwareMicroscopeDefault_1 = __decorate([
    customElement('zui-icon-hardware-microscope-default')
], IconHardwareMicroscopeDefault);
export { IconHardwareMicroscopeDefault };
